const TEXT_TAGS = new Set(["INPUT", "TEXTAREA"]);

/**
 * Dismiss soft keyboard before a footer CTA click so the first tap is not
 * eaten by iOS/Android focus blur.
 */
export function blurActiveTextInput(): void {
  const el = document.activeElement as HTMLElement | null;
  if (!el) return;
  if (!TEXT_TAGS.has(el.tagName) && !el.isContentEditable) return;
  el.blur();
}
